<template>
  <div class="show-status">
    <div v-if="isMissing" class="chip-smaller">
      <v-chip label color="red">
        <span class="white--text">
          {{ $t("wallet:EventFinancesPage.prizesTab.dataMissing.badge.label") }}
        </span>
      </v-chip>
    </div>

    <v-chip v-else-if="isUnknown" label color="orange">
      <span class="white--text">
        {{
          $t("wallet:payout.underInvestigation", "Under Investigation")
        }}</span
      >
    </v-chip>

    <div v-else class="chip-smaller">
      <v-chip label :color="chipColor">
        <span class="white--text">{{
          $t(`wallet:payout.status.${value.status}.label`, value.status)
        }}</span>
      </v-chip>

      <div v-if="withDetails">
        {{ $dayjs.date(statusDate) }}
        <br />
        <span v-if="statusDate" class="muted--text">
          {{ $dayjs(statusDate).format("HH:mm:ss") }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import gql from "fraql";
import { usePayoutStatusHelper } from "./showPayoutStatus";

export default {
  name: "AppShowPayoutStatus",
  props: {
    value: {
      type: Object,
      required: true
    },
    withDetails: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      isMissing,
      isUnknown,

      statusDate,
      statusClass,
      chipColor
    } = usePayoutStatusHelper(props);

    return {
      isMissing,
      isUnknown,

      statusDate,
      statusClass,
      chipColor
    };
  },
  fragments: {
    payout: gql`
      fragment _ on Payout {
        status
        processingResolution
        fromEventId
        results {
          id
          registration {
            id
            allowedMutations
          }
        }
        createdAt
        confirmedAt
        cancelledAt
      }
    `
  }
};
</script>
